export default __webpack_public_path__ + "static/media/modal-confirm-questionMark.02c10bee.svg";